import { ReactNode } from 'react'
import { useAuth } from '../context/AuthContext'
import { UserTypes } from '@/shared/types/auth'

type PermissionGateProps = {
    allowedTypes: UserTypes[]
    fallback?: ReactNode
    children: ReactNode
}

/**
 * Component that is a wrapper to check permissions
 *
 *
 *
 * Example of Using the PermissionGate component:
 ```jsx
 function ParentDashboard() {
  return (
    <div>
      <PermissionGate 
        allowedTypes={[UserTypes.IS_PARENT, UserTypes.IS_ADMIN_TEACHER]}
        fallback={<p>Access Denied</p>}
      >
        <ParentControls />
      </PermissionGate>

      <PermissionGate 
        allowedTypes={[UserTypes.IS_TEACHER, UserTypes.IS_GLOBAL_ADMIN]}
      >
        <TeacherDashboard />
      </PermissionGate>
    </div>
  );
}
 ```
 */

export default function PermissionGate({
    allowedTypes,
    fallback = null,
    children
}: PermissionGateProps) {
    const { userTypes } = useAuth()

    const hasPermission = userTypes?.some((type) => allowedTypes.includes(type)) || false

    if (!hasPermission) {
        return <>{fallback}</>
    }

    return <>{children}</>
}
